import Provider from '@/classes/sso/Provider'

export default class Providers extends Array {
  constructor (providers, ...rest) {
    Array.isArray(providers) ?
      super(...providers
        .map(provider => new Provider(provider))
        .filter(provider => provider.is_allowed))
        .sort((a, b) => {
          if (a.category === 'custom' && b.category !== 'custom') return -1
          if (b.category === 'custom' && a.category !== 'custom') return 1

          return a.name.localeCompare(b.name)
        })
      : super(...rest)
  }
}